import React from 'react';
import PropTypes from 'prop-types';

import { TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP } from '../../constants';

const propTypes = {

	/**
	 * The iframe url.
	 */
	src: PropTypes.string,

	/**
	 * The aspect ratio for the iframe.
	 */
	aspectRatio: PropTypes.string,

	/**
	 * The title for the iframe.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * The querystring options for the iframe.
	 */
	query: PropTypes.string,

	/**
	 * The list of allowed attributes.
	 */
	allow: PropTypes.string,

};

const defaultProps = {
	aspectRatio: TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP,
};

const IFrame = (props) => {

	const {
		src,
		aspectRatio,
		title,
		query,
		allow,
	} = props;

	let url = src;

	// Check if url already includes a query string
	if (query) {
		if (url.indexOf('?') > -1) {
			url = `${url}&${query}`;
		} else {
			url = `${url}?${query}`;
		}
	}

	return (
		<div className={`ratio ratio-${aspectRatio}`}>
			<iframe
				src={url}
				title={title}
				frameBorder="0"
				allow={allow}
				allowFullScreen />
		</div>
	);

};

IFrame.propTypes = propTypes;
IFrame.defaultProps = defaultProps;

export default IFrame;
